(()=>{
function mount(root=document){
 root.querySelectorAll('.product-zoom').forEach(dialog=>{
  if(dialog.dataset.cpReady)return;dialog.dataset.cpReady='1';
  const stage=dialog.querySelector('.cp-zoom-scroll'),status=dialog.querySelector('[data-zoom-status]');
  if(!stage)return;
  const zoom=on=>{stage.classList.toggle('is-enlarged',on);status.textContent=on?'200 %':'100 %';requestAnimationFrame(()=>{stage.scrollTop=on?Math.max(0,(stage.scrollHeight-stage.clientHeight)/2):0;stage.scrollLeft=on?Math.max(0,(stage.scrollWidth-stage.clientWidth)/2):0;});};
  dialog.querySelector('[data-zoom-in]').addEventListener('click',()=>zoom(true));
  dialog.querySelector('[data-zoom-out]').addEventListener('click',()=>zoom(false));
  stage.querySelector('img').addEventListener('click',()=>zoom(!stage.classList.contains('is-enlarged')));
  dialog.addEventListener('close',()=>zoom(false));
 });
 root.querySelectorAll('[data-lexicon]').forEach(box=>{
  if(box.dataset.ready)return;box.dataset.ready='1';
  const input=box.querySelector('[data-lexicon-search]'),topic=box.querySelector('[data-lexicon-topic]'),entries=[...box.querySelectorAll('[data-lexicon-entry]')];
  const clean=s=>s.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  const update=()=>{let n=0;for(const item of entries){item.hidden=!(clean(item.textContent).includes(clean(input.value))&&(!topic.value||item.dataset.topic===topic.value));if(!item.hidden)n++;}box.querySelector('[data-lexicon-status]').textContent=n+' von '+entries.length+' Begriffen';box.querySelector('[data-lexicon-empty]').hidden=n!==0;};
  input.addEventListener('input',update);topic.addEventListener('change',update);box.querySelector('[data-lexicon-reset]').addEventListener('click',()=>{input.value='';topic.value='';update();input.focus();});update();
 });
}
mount();document.addEventListener('shopify:section:load',e=>mount(e.target));
})();
